import React, { useContext, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../helpers/AuthContext";

function CreatePost() {
	const { authState } = useContext(AuthContext);

	let history = useHistory();
	const initialValues = {
		title: "",
		postText: "",
	};

	useEffect(() => {
		if (!localStorage.getItem("accessToken")) {
			history.push("/login");
		}
	}, []);

	const validationSchema = Yup.object().shape({
		title: Yup.string().required("Title please!!"),
		postText: Yup.string().required(),
	});

	const onSubmit = (data) => {
		axios
			.post("https://trilog-social-media.herokuapp.com/posts", data, {
				headers: { accessToken: localStorage.getItem("accessToken") },
			})
			.then((response) => {
				history.push("/");
			});
	};

	return (
		<div className="createPostPage">
			<Formik
				initialValues={initialValues}
				onSubmit={onSubmit}
				validationSchema={validationSchema}
			>
				<Form className="formContainer">
					<label>Title: </label>
					<ErrorMessage name="title" component="span" />
					<Field
						autocomplete="off"
						id="inputCreatePost"
						name="title"
						placeholder="( Your Title....)"
					/>
					<label>Post: </label>
					<ErrorMessage name="postText" component="span" />
					<Field
						autocomplete="off"
						id="inputCreatePost"
						name="postText"
						placeholder="( Ex. Post....)"
					/>

					<button type="submit">CreatePost</button>
				</Form>
			</Formik>
		</div>
	);
}

export default CreatePost;
